import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—February 2005" />
	<Old2005BlogPage>
		<h2>February 2005</h2>



		<h3 className="blogdate">
		Sunday, February 27, 2005
		</h3>





		<h4 className="blogitemtitle">
		Saturday afternoon at Cafe Mauro
		</h4>





			<div className="blogitembody">
			I spent a half hour playing some songs at Cafe Mauro this afternoon.  Sal was relieved when I walked in with my guitar because he is tired of hearing hours of jazz on CKUA (on Saturdays).  So I started off with my newly learned song "Waiting" by Lester Quitzau, which caused some applause from one of the patrons!  I'm planning on playing more often at Cafe Mauro - some late afternoons on weekdays, and more Saturday afternoons.  It beats practicing at home, and Sal appreciates it!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 8:46 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Saturday, February 26, 2005
		</h3>





		<h4 className="blogitemtitle">
		Troubles on Wednesday nights
		</h4>





			<div className="blogitembody">
			I've been having difficulties with Wednesday night open mics, specifically at Ironwood and Karma.  Two Wednesdays ago I went to Ironwood and my name was bumped on the list (which means I didn't get to play).  Note that <em>Tom Phillips</em> got to play though, and I doubt that his name was on the list (because he plays there every Friday night for money).  I got over it pretty quick though, as it was my birthday and some friends and I went down the road to the Hose and Hound for a final beer and some cigars.<br /><br />The last two times that I went to Karma on Wednesdays I was unlucky - they have a lottery to see who plays next, and my name wasn't drawn before 12:00 and I became to tired and smoked-out to stay.  Karma sure is a popular place, and I have to say that it has the worst sound of the places I go.  I went this Wednesday and there were a few good acts up... really good acts.  And I sat with <em>Youssou Seck</em> for a beer or two; I've seen him play at some other open mics and also with Aaron Young.  I believe that Youssou, along with the group members of Takadja, won a Juno award in the last year or two for best global album.  Very cool!  I invited him to come to Eddie Bo Dean's on any future Sunday night.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:21 AM &nbsp;


			</div>





		<h3 className="blogdate">
		Tuesday, February 22, 2005
		</h3>





		<h4 className="blogitemtitle">
		Late night at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			I showed up at Eddie's last night and the stage lights weren't on, and only Rebecca and Josh were there (among lots of other pub patrons that don't participate in the open mic). They were very happy to see me as I was the first to show (which surpised me as it was 9:30). They bought me a Guinness with their bar tab and got the show started.<br /><br />I went up after Rebecca and even by that time some other musicians started to arrive. I played three Tea Party songs in an open C tuning: "Sister Awake", "Winter Solstice", and "Sun Going Down". People enjoyed hearing these songs, or perhaps moreso hearing someone play non-usual songs in a non-usual tuning. People mostly liked "Sun Going Down" because of the slide guitar and the style of the song. After my set, Josh asked if I would come to the recording studio and record - I will be a test subject for his student (he teaches recording engineering). I of course said "Absolutely!"<br /><br />There's another fellow that comes occasionally, named Tyler, that plays slide blues - he deserves an honorable mention. His tuning was a little out but it was still very cool to hear him play - a refreshing break from the usual stuff you hear. Greg went up again and played a good set of songs, this time my favorite was probably "Lost Together" by Blue Rodeo, and Josh and I went up and provided backup vocals to this song.<br /><br />Later, a bluesy fellow named Dan wanted some accompaniment so I played some basic 12 bar blues while he went nuts on the guitar... he's fairly fast and has a flair for Stevie Ray Vaughan. I think he's really young and already quite good, so watch out for this guy in a few years!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 8:09 AM &nbsp;

			</div>





		<h3 className="blogdate">
		Sunday, February 20, 2005
		</h3>





		<h4 className="blogitemtitle">
		Magical Evening in Banff
		</h4>





			<div className="blogitembody">
			Last night I saw Lester Quitzau and Mae Moore play at the Margaret Greenham Theatre (Banff Center for the Performing Arts)!  It was definitely a magical evening, with the moon illuminating the Banff-surrounding, snow-covered mountains, and a pleasantly wintery chill in the air.  I sat 3d row center and had an awesome view of Lester's and Mae's equipment as the seats in the theatre filled around me.  I was sitting by myself and there is only one person that I wish could have been with me (she knows who she is).<br /><br />Lester had two guitars, one simple looking hollow body with a classical headstock, and one beautiful resonator guitar with lightning-bolt cut-outs.  Mae had a beautiful looking Larrivée guitar.  At one point in the evening, they played a song about rain that Mae wrote in 1979, and for this song Mae played an Appalachian Dulcimer while Lester played an African Imbura (Imbura means rain) - this was a very cool break in the show.  Mae has a wonderful voice and plays in what seems to be a non-standard tuning, or non-standard chords that offer wonderful voicings to the music.  As for Lester, well... he's Lester (which means he plays fantastic slide blues).  It is a joy to watch him play as his eyes close and his mouth staggers somewhat open - he really gets into playing his guitar.<br /><br />Another cool moment came in the second set when they played "Little Wing" by Jimi Hendrix, and Bob Dylan's "Buckets of Rain".  I also learned that "Time Takes Time" is Mae's favorite song of Lester's:  Mae fell in love with the song once hearing it on the radio and it wasn't until later, when she and Lester were on their first date, trading songs, that Mae learned it was Lester's song!  I thought that was a nice story.  Lester and Mae seem to be very happy together - they have been coined as "musical soulmates".<br /><br />At the end of the show I purchased Lester's CD "So Here We Are" - I felt compelled to do so since I have been enjoying a copy of this CD for some time.  I have thrown the copy out and now have the original, which I had Lester autograph, and also comes with some digital videos on it that can be viewed with a computer.  I also wanted to buy Lester's and Mae's recent CD called "Oh My" as they played several great songs from this CD during the concert... but I'm on a budget... next time!<br /><br />Links:<br /><a href="http://www.maemoore.com/">http://www.maemoore.com/</a><br /><a href="http://www.lesterq.com/">http://www.lesterq.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:51 AM &nbsp;


			</div>





		<h3 className="blogdate">
		Friday, February 18, 2005
		</h3>





		<h4 className="blogitemtitle">
		Crazy French Girl
		</h4>





			<div className="blogitembody">
			I thought I'd do a quick recording of Crazy French Girl, for your listening pleasure.  Check it out!<br /><br />Links:<br /><Link to="/music/">http://www.jesserivest.com/music/</Link>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 4:23 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Monday, February 14, 2005
		</h3>





		<h4 className="blogitemtitle">
		Crazy French Girl at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			After being sick for a week, it was nice to get back to an open mic venue... Tonight was Eddie Bo Dean's again.  Honorable mention goes to Rebecca (the host) and her fabulous singing, also to Greg for playing Lady in Red (hilarious but well done), and some more Bruce Springsteen.  Another fellow, Kali (I gotta learn to spell his name) played fretless bass quite well, as well as guitar and singing.  I saw him at Eddie's the first time I went and he sang songs with a keyboard - I'd say he is multi-talented.<br /><br />Greg brought his friend Chantal tonight and she was had a great time watching us and the other talented folks play.  I was hoping a friend of mine would come as well... next time I guess.  I'm pretty flippin' tired now, so I'll end off with the songs I played:<br /><br />Pearl Jam - Daughter<br />Jesse Rivest - Deadbeat Blues<br />Jesse Rivest - Crazy French Girl<br /><br />These are the only three songs I know in an open G tuning.  Daughter was well liked, however people definitely like Deadbeat Blues, even though I screwed up the lyrics twice!  And I received some comments on my slide playing in Crazy French Girl.  I'll record Crazy French Girl soon, I am just finalizing the parts of the song.  Good times!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 9:16 PM &nbsp;

			</div>





		<h3 className="blogdate">
		Tuesday, February 08, 2005
		</h3>





		<h4 className="blogitemtitle">
		Eddie Bo Dean's with a new pickup in my guitar!
		</h4>





			<div className="blogitembody">
			Last night I went to Eddie Bo Dean's "open stage" again; it started out slow (perhaps because of Superbowl evening).  I just recently purchased a <em>K&K Sound Pure Western</em> transducer, for my cedar-top Simon and Patrick, from Mike at Acousticguitar.net.  Mike is a very easygoing fellow with some excellent Canadian guitars in stock; I look forward to visiting him again one day.  I had Miles from Fretworks install the transducer for me; he is a reputable guitar mechanic and luthier in Calgary.  My guitar sounded warm, clear and natural through the PA and I am quite happy.
<br />
<br />I played some E tuning songs when my turn came:
<br />
<br />Xavier Rudd - Solace Amongst the Sin
<br />Xavier Rudd - No Woman No Cry (Bob Marley)
<br />The Black Crowes - Talks to Angels
<br />
<br />The songs were well received, and have been at a few past appearances; I plan to keep them in my set!  I ran into Greg again; he played a few songs including "Born to Run" by Bruce Springsteen, and Gordon Lightfoot's "If You Could Read My Mind"... both were quite good.  He plays harmonica with the guitar which is cool.
<br />
<br />Links:
<br /><a href="http://acousticguitar.net/">http://acousticguitar.net/</a>
<br /><a href="http://www.kksound.com/">http://www.kksound.com/</a>
<br /><a href="http://www.fretwork.com/">http://www.fretwork.com/</a>
<br /><a href="http://www.simonandpatrick.com/">http://www.simonandpatrick.com/</a>
<br />
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 10:46 AM &nbsp;


			</div>





		<h3 className="blogdate">
		Tuesday, February 01, 2005
		</h3>





		<h4 className="blogitemtitle">
		Sunday night - Open Stage at Eddie Bo Dean's
		</h4>





			<div className="blogitembody">
			In my quest to find more open mic sessions in Calgary, I stumbled upon Sunday night at Eddie Bo Dean's.  The host Rebecca has a great voice and plays guitar and keyboards (and maybe more?).  I don't care for the venue as much as Ironwood or Karma (although Karma can get pretty smoky), however some of the regulars are talented musicians.  I went up early and found that the electromagnetic pickup for my guitar is not working... shitty.  Rebecca let me use her guitar, an Ovation model with a curved back... I had a helluva time keeping it on my lap while playing!  I played  "Broken Heart" and "Time Takes Time" by Lester Quitzau, plus I threw in "Dragon and Kitty".  It was my first time playing it for people and I'm not sure they liked it, but I don't care!  I plan to bounce it off some other people as well; I know it's a goofy song but I like the groove.  I like the song.
<br />
<br />I need to install a piezo/ribbon pickup in my guitar because I have nothing now, and that electro pickup has crappy sound, anyways.
<br />
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 7:46 AM &nbsp;
			</div>



			<p>
				<Link to="/blog2005/">Go back to the blog index page</Link>
			</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
